/**
 * Represents a file.
 */
export interface File {
  /**
   * The unique identifier of the media in mediaManager.
   */
  mediaId: string;

  /**
   * The size of the file in bytes.
   */
  sizeInBytes: number;

  /**
   * The type of media.
   */
  mediaType: 'picture' | 'audio' | 'video' | 'document';

  /**
   * The display name of the file.
   */
  displayName: string;

  /**
   * Whether the file is private.
   */
  private: boolean;
}

export interface FileViewProps {
  file: File;
  showDownloadCTA?: boolean;
  showDetails?: boolean;
}
